import React from "react";
import { Link, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import { Box, IconButton, Button } from "@mui/material";
import Api from "./Api";
import { BASE_API_URL, version } from "./const"; // Импортируем BASE_API_URL

const Header = ({ setManageBlock }) => {
  const navigate = useNavigate();
  const userString = localStorage.getItem("cinema.Login");

  const handleLogout = async () => {
    try {
      // Отправляем запрос на /user/logout
      await Api.post(`${BASE_API_URL}/api/user/logout`, {});

      // Очищаем localStorage
      localStorage.removeItem("cinema.Login");
      localStorage.removeItem("cinema.Token");
      // Перенаправляем пользователя на страницу авторизации
      navigate("/auth");
    } catch (error) {
      console.error("Ошибка при выходе:", error);
    }
  };

  const handleToggleManageBlock = () => {
    setManageBlock((prev) => !prev);
  };

  return (
    <header
      style={{
        height: "20px",
        marginBottom: 10,
        padding: "5px",
        backgroundColor: "#1976d2",
        color: "#fff",
        fontSize: "10px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center", // Центрирование по вертикали
          justifyContent: "space-between",
          height: "100%", // Используем полную высоту контейнера
        }}
      >
        {/* Иконка "домой" слева */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center", // Центрирование по вертикали
            justifyContent: "space-between",
            height: "100%", // Используем полную высоту контейнера
          }}
        >
          <Link to="/" style={{ textDecoration: "none" }}>
            <IconButton>
              <HomeIcon sx={{ color: "#E0F7FA", fontSize: "25px" }} />
            </IconButton>
          </Link>
          <a
            href="/met"
            style={{
              textDecoration: "none", // Убираем подчеркивание
              color: "#E0F7FA", // Цвет текста
              fontSize: "12px", // Размер текста
              fontWeight: "bold", // Жирный текст
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            MET
          </a>
          <a
            href="https://api.vlc-control.idc.md/api/epg/1"
            style={{
              textDecoration: "none", // Убираем подчеркивание
              color: "#E0F7FA", // Цвет текста
              fontSize: "12px", // Размер текста
              fontWeight: "bold", // Жирный текст
              marginLeft: "10px",
            }}
            target="_blank"
            rel="noopener noreferrer"
          >
            EPG
          </a>
          <span
            style={{
              fontSize: "12px",
              marginRight: "auto",
              marginLeft: "20px",
            }}
          >
            {`версия ${version}`}
          </span>
          <span
            style={{
              fontSize: "12px",
              marginRight: "20px",
            }}
          >
            ({/dev/.test(BASE_API_URL) ? "dev" : "prod"})
          </span>

          <span
            onClick={handleToggleManageBlock}
  style={{
    cursor: "pointer",
    marginLeft: "20px",
  }}>Управление блоками</span>
        </Box>

        {/* Центральная надпись */}
        <Box
          onClick={() => window.location.reload()}
          sx={{
            cursor: "pointer",
            flexGrow: 1,
            textAlign: "center",
          }}
        >
          <span
            style={{
              fontSize: "25px",
              fontWeight: "bold",
              color: "#ffffff",
            }}
          >
            Синема КТВ
          </span>
        </Box>

        {/* Надпись "User" и кнопка "Выход" справа */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <span style={{ fontSize: "16px", marginRight: "auto" }}>
            {userString}
          </span>
          <Button
            onClick={handleLogout}
            variant="text"
            size="small"
            sx={{
              color: "#E0F7FA", // Цвет текста
              padding: "2px 8px", // Уменьшаем внутренние отступы
              minWidth: "auto", // Убираем минимальную ширину
              fontSize: "10px", // Меньший размер текста
              textTransform: "none", // Оставляем текст как есть
            }}
          >
            Выход
          </Button>
        </Box>
      </Box>
    </header>
  );
};

export default Header;
